<template>

  <div class="form-group" v-if="render">
    <label :title="tooltip(element.label)">
      {{ t(element.label) }}
      <icons-render :propIcons="element.icons"/>
    </label>
    <input
      v-model="value"
      :name="element.name"
      :type="type"
      v-bind:class="{'empty': !value}"
      :readonly="element.readonly"
      @keyup="_changeValue"
      @blur="_blur"
      class="form-control"
      ref="input"
    />
  </div>

</template>

<script>
import IconsRender from '../../templates/widgets/icons-render'
import DictionaryLoader         from '@/model/loader/dictionary-loader'

export default {
  name:       'input-box',
  components: {
    IconsRender
  },
  props:      {
    element: {
      required: true,
      type:     Object,
      default:  () => {
        return {
          name:     null,
          type:     null,
          dataType: null,
          label:    null
        }
      }
    }
  },

  data () {
    return {
      value:         null,
      type:          'password',
      originalValue: null,
      jqueryElement: null,
      useMaskInput:  false,
      render:        true
    }
  },

  created () {

  },

  mounted () {

  },

  methods: {

    /**
     *
     * @param value
     */
    updateValue (value) {
      value = value.value

      this.value         = value
      this.originalValue = value
    },

    /**
     *
     * @param values
     * @param fieldName
     */
    updateHighlighters (values, fieldName) {
      this.element.icons.forEach((icon) => {
        if (icon.def.ColumnName === fieldName) {
          icon.value = JSON.parse(values.value)
        }
      })
    },

    /**
     *
     * @private
     */
    _changeValue () {
      this.$emit('changeValue', { element: this.element, value: this.value })
    },

    /**
     *
     * @private
     */
    _blur () {
      if (this.originalValue === this.value) {
        return
      }

      this.$emit('blur', { element: this.element, value: this.value })
    },

    /**
     *
     * @private
     */
    _clear () {
      if (this.useMaskInput) {
        this.jqueryElement.val('')
      }

      this.value = null

      this._changeValue()
      this._blur()

      $(this.$refs.input).focus()
    },

    setRender (render) {
      this.render = render
    },

    tooltip (key) {
      return DictionaryLoader.tooltip(key, this.$user.languageCode)
    }

  }
}
</script>
